import React from "react";
import BaseDialog from "./BaseDialog";
import Input from "../../form_components/Input";

export default class VariableSubstitutionDialog extends BaseDialog {
    /**
     * Dialog for variable substitution for dialog editor
     * @module VariableSubstitutionDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.addHandle = this.handleAdd.bind(this);

        const dialog = window.apm.serialized.dialogs.find(d => d.id === this.props.dialogId);
        if (dialog) {
            const substitutions = {};
            if (dialog.nodes && dialog.nodes.length) {
                dialog.nodes.filter(n => n.type === "prompt").forEach(p => {
                    const prompt = window.apm.getNode(p.parentComponentID);
                    if (prompt && prompt.props.config.inputs) {
                        prompt.props.config.inputs.forEach(i => {
                            if (i && i.varName && !substitutions.hasOwnProperty(i.varName)) {
                                substitutions[i.varName] = dialog.substitutions ? dialog.substitutions[i.varName] : "";
                            }
                        });
                    }
                });
            }
            this.state = substitutions;
        }
    }

    setConfig(key, value) {
        this.setState({
            [key]: value
        });
    }

    getConfig(key) {
        return this.state[key];
    }

    /**
     * Handle add to module event
     * @param event
     */
    handleAdd(event) {
        window.apm.setDialogConfig(this.props.dialogId, "substitutions", this.state);
        w2popup.close();
    }

    componentDidMount() {
        super.componentDidMount();
        document.addEventListener("ev-var-substitute", this.addHandle);
    }

    unregister() {
        document.removeEventListener("ev-var-substitute", this.addHandle);
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const variables = Object.keys(this.state);
        return (
            <div>
                <div className={"container-fluid element-dialog element-body"}>
                    <div className={"row"}>
                        <div className="col-md-12">
                            {variables.length === 0 && <p>No variable used in this dialog.</p>}
                            {variables.map(variable => {
                                return <Input label={variable} key={variable}
                                       value={this.state[variable]}
                                       context={this} valKey={variable}/>;
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}